import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ArquivosAplicativo {
    urlLogo: string | null
    urlImgAindaNaoTemSelo: string | null
    urlImagemCabecalho: string | null
    urlArquivoFireBase: string | null
    urlSelo: string | null
    urlBotaoCarimbar: string | null
    urlRodape: string | null
    urlFundoGenerico: string | null
    urlSplash: string | null
    urlImagemDelivery: string | null
    urlImagemLojas: string | null
    urlImagemComSelo: string | null
    urlImgTelaSelos: string | null
    urlImgTelaPromocao: string | null
    urlFundoSite: string | null
    urlImgBaner: string | null
    podeEditar: boolean
    ehClienteFiel: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterArquivos = async function (
    authorization: string
): Promise<ArquivosAplicativo | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ArquivosAplicativo>>("aplicativoDados/ObterArquivosAplicativo", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ArquivosAplicativo>(response, "ObterArquivosAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "ObterArquivosAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const uploadArquivo = async function (
    authorization: string,
    campo: string,
    file: File
): Promise<{ url: string } | ErroApi> {
    try {
        const response = await api
            .put<RespostaRaw<{ url: string }>>(
                `aplicativoDados/UploadArquivoAplicativo/${campo}`,
                file,
                {
                    headers: {
                        "Content-Type": "application/octet-stream",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ url: string }>(response, "UploadArquivoAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "UploadArquivoAplicativo", campo)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const removerArquivo = async function (
    authorization: string,
    campo: string
): Promise<void | ErroApi> {
    try {
        type RespostaDelete = { codErro?: number; mensagem?: string }
        const response = await api
            .delete<RespostaDelete>(`aplicativoDados/RemoverArquivoAplicativo/${campo}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaDelete }
            })

        if (response.data && response.data.codErro !== undefined && response.data.codErro > 0) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "RemoverArquivoAplicativo", campo)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
